var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1832 3.74475C8.74331 3.74475 8.13478 4.43185 7.13199 4.43185C6.10384 4.43185 5.31961 3.74975 4.07183 3.74975C2.85049 3.74975 1.54807 4.49542 0.720984 5.76569C-0.440367 7.557 -0.243237 10.9307 1.63771 13.8048C2.31052 14.8337 3.20903 15.9875 4.38753 16H4.40895C5.43317 16 5.73744 15.3293 7.14699 15.3215H7.16841C8.55689 15.3215 8.83545 15.9961 9.85538 15.9961H9.8768C11.0553 15.9836 12.002 14.7051 12.6748 13.6802C13.1591 12.9431 13.3391 12.5731 13.7105 11.7392C10.9896 10.7064 10.5525 6.84919 13.2434 5.37036C12.422 4.34185 11.2678 3.74618 10.1796 3.74618L10.1832 3.74475Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86608 0C9.009 0.0582104 8.00906 0.603888 7.42339 1.31634C6.892 1.96201 6.45488 2.91981 6.6263 3.84867H6.69487C7.60766 3.84867 8.54189 3.29907 9.08756 2.59483C9.61324 1.92452 10.0118 0.974578 9.86608 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMusic);
export default __webpack_public_path__ + "static/media/appleMusic.ebccb445.svg";
export { ForwardRef as ReactComponent };